import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import {
  ArticleOutline,
  listArticleOutlines,
} from "#/services/articleOutlines";

export function useArticleOutlinesList() {
  return useQuery<ArticleOutline[]>({
    queryKey: qk.articleOutlines(),
    queryFn: ({ signal }) => listArticleOutlines({ signal }),
    staleTime: 30_000,
    refetchOnMount: "always",
  });
}

export default useArticleOutlinesList;
